import styled, { css } from 'styled-components';
import theme from '../../styles/theme';

export interface IconProps {
  cursor?: 'not-allowed' | 'pointer' | 'default' | 'none';
  modifier?: 'regular' | 'strong' | 'weak' | 'inverted';
  variant?:
    | 'primary'
    | 'secondary-1'
    | 'secondary-2'
    | 'secondary-3'
    | 'neutral'
    | 'danger'
    | 'warning'
    | 'info'
    | 'success';
  disabled?: boolean;
}

export const Icon = styled.i<IconProps>`
  font-style: normal;
  display: flex;
  align-items: center;
  ${({ variant, modifier }) => setStyleSvgPath(variant, modifier)}
  ${({ cursor }) => css`
    cursor: ${cursor};
  `}
`;

const setStyleSvgPath = (variant, modifier) => {
  // Validar que el variant y modifier existan antes de acceder
  const variantColors = theme.colors[variant];
  if (!variantColors || !variantColors.ic) {
    return css``;
  }
  
  const modifierColor = variantColors.ic[modifier] || variantColors.ic.regular;
  
  return css`
    svg {
      path {
        fill: ${modifierColor};
      }
    }
  `;
};
